module.exports = __webpack_public_path__ + "img/sound-open.5d60fae2.svg";